///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validateGateWayBySubnetwork } from './subnetwork-validation';

export const GtthDefaultGatewaySubnetValidation = (subnetMask: number, startIp: string): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value && subnetMask && startIp) {
            const isValid = validateGateWayBySubnetwork(control.value, startIp, subnetMask);
            return isValid ? null : { subnetValidation: true };
        }

        return null;
    };
};
